import { render } from "./ConcertView.vue?vue&type=template&id=1dcd0e1e&scoped=true"
import script from "./ConcertView.vue?vue&type=script&lang=js"
export * from "./ConcertView.vue?vue&type=script&lang=js"

import "./ConcertView.vue?vue&type=style&index=0&id=1dcd0e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcd0e1e"]])

export default __exports__